export default{
  crossChecksHelpers: (state) => state.crossChecksHelpers,
  compareHelpers: (state) => state.compareHelpers,
  compareFeeHelpers: (state) => state.compareFeeHelpers
}



// WEBPACK FOOTER //
// ./src/components/compare/store/getters.js